// Sprechende Share-URLs für Trainingseinheiten (muss zur Backend-Logik passen).
import { BACKEND_URL } from "@/lib/api";

const UMLAUT = { ä: "ae", ö: "oe", ü: "ue", ß: "ss" };

export function slugifyText(text) {
  let t = (text || "").toLowerCase().trim();
  t = t.replace(/[äöüß]/g, (c) => UMLAUT[c] || c);
  t = t.replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  return t || "trainingseinheit";
}

// '2026-09-28' -> '28-09-2026'
function dateSlug(iso) {
  if (!iso) return "";
  const p = String(iso).split("T")[0].split("-");
  if (p.length !== 3) return "";
  return `${p[2]}-${p[1]}-${p[0]}`;
}

export function buildSessionShareSlug(datum, name) {
  const d = dateSlug(datum);
  const n = slugifyText(name);
  return (d ? `${d}-${n}` : n) || "trainingseinheit";
}

// Vollständiger Share-Link (über Backend → Open-Graph-Vorschau, leitet Menschen weiter).
export function buildSessionShareUrl(datum, name, token) {
  const slug = buildSessionShareSlug(datum, name);
  return `${BACKEND_URL}/api/ts-share/${slug}/${token}`;
}
